import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { map } from 'rxjs/operators';

// Config
import { Config } from '../config/config';

const httpOptions = {
  headers: new HttpHeaders({
    'Content-Type': 'application/json; charset=UTF-8;'
  })
}

@Injectable()
export class NotificationsService {
  data: any;

  constructor( 
    public http: HttpClient
  ) {
  }

  getNotifications()
  {
    return this.http.get( Config.API_ROOT_INSTRUCTORS + 'notifications' )
      .pipe( map( this.processData, this ));
  }

  clearNotification( notification )
  {
    return this.http.put( Config.API_ROOT_INSTRUCTORS + 'notifications/' + notification.notification_id, JSON.stringify(notification), httpOptions );
  }

  clearNotificationsByItemIdItemType(itemId, itemType)
  {
    return this.http.put( Config.API_ROOT_INSTRUCTORS + 'notifications-by-item/' + itemId + '?item-type=' + itemType, null, httpOptions );
  }

  clearAllNotifications()
  {

  }

  processData(data: any) 
  {
    this.data = data;

    return this.data;
  } 
}  


// WEBPACK FOOTER //
// ./src/providers/notifications/notifications-service.ts